/* nord-related-products — JS estático extraído do <script> inline.
   Sem Liquid: idêntico em toda página, então vira asset cacheável. */
(function () {
    if (!customElements.get('nord-related-products')) {
      class NordRelatedProducts extends HTMLElement {
        connectedCallback() {
          this.bindCarousel();

          if (this.dataset.nordLoaded === 'true') return;
          var url = this.dataset.url;
          if (!url) return;

          var self = this;
          var load = function () {
            if (self.dataset.nordLoaded === 'true') return;
            self.dataset.nordLoaded = 'true';
            fetch(url)
              .then(function (response) {
                return response.text();
              })
              .then(function (text) {
                var doc = new DOMParser().parseFromString(text, 'text/html');
                var fresh = doc.querySelector('nord-related-products');
                if (!fresh || !fresh.innerHTML.trim().length) return;
                self.innerHTML = fresh.innerHTML;
                self.bindCarousel();
              })
              .catch(function () {});
          };

          if ('IntersectionObserver' in window) {
            var observer = new IntersectionObserver(
              function (entries) {
                entries.forEach(function (entry) {
                  if (!entry.isIntersecting) return;
                  observer.disconnect();
                  load();
                });
              },
              { rootMargin: '0px 0px 600px 0px' }
            );
            observer.observe(this);
          } else {
            load();
          }
        }

        bindCarousel() {
          var list = this.querySelector('.nord-rp__list');
          var prev = this.querySelector('.nord-rp__nav--prev');
          var next = this.querySelector('.nord-rp__nav--next');
          if (!list || !prev || !next || list.dataset.nordBound === 'true') return;
          list.dataset.nordBound = 'true';

          var step = function () {
            var item = list.querySelector('.nord-rp__item');
            return item ? item.getBoundingClientRect().width + 1 : list.clientWidth;
          };

          var sync = function () {
            var overflowing = list.scrollWidth - list.clientWidth > 2;
            prev.hidden = !overflowing || list.scrollLeft <= 2;
            next.hidden = !overflowing || list.scrollLeft + list.clientWidth >= list.scrollWidth - 2;
          };

          prev.addEventListener('click', function () {
            list.scrollBy({ left: -step(), behavior: 'smooth' });
          });
          next.addEventListener('click', function () {
            list.scrollBy({ left: step(), behavior: 'smooth' });
          });
          list.addEventListener('scroll', sync, { passive: true });
          window.addEventListener('resize', sync);
          sync();
        }
      }

      customElements.define('nord-related-products', NordRelatedProducts);
    }

    if (!customElements.get('nord-product-card')) {
      class NordProductCard extends HTMLElement {
        connectedCallback() {
          this.button = this.querySelector('button.nord-card__quick-buy');
          if (!this.button || this.button.dataset.nordBound === 'true') return;
          this.button.dataset.nordBound = 'true';
          this.button.addEventListener('click', this.onQuickBuy.bind(this));
        }

        onQuickBuy(event) {
          event.preventDefault();

          var button = this.button;
          var variantId = button.dataset.variantId;
          var addUrl = button.dataset.cartAddUrl || '/cart/add';
          var cartUrl = button.dataset.cartUrl || '/cart';
          if (!variantId || button.getAttribute('aria-busy') === 'true') return;

          var drawer = document.querySelector('cart-drawer, cart-notification');
          var sections = [];
          if (drawer && typeof drawer.getSectionsToRender === 'function') {
            sections = drawer.getSectionsToRender().map(function (section) {
              return section.id;
            });
          }

          button.setAttribute('aria-busy', 'true');

          fetch(addUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
            body: JSON.stringify({
              items: [{ id: variantId, quantity: 1 }],
              sections: sections,
              sections_url: window.location.pathname
            })
          })
            .then(function (response) {
              return response.json();
            })
            .then(function (parsed) {
              if (parsed.status) {
                window.location.href = button.dataset.productUrl || cartUrl;
                return;
              }
              if (drawer && typeof drawer.renderContents === 'function') {
                if (drawer.classList) drawer.classList.remove('is-empty');
                drawer.renderContents(parsed);
                return;
              }
              window.location.href = cartUrl;
            })
            .catch(function () {
              window.location.href = cartUrl;
            })
            .finally(function () {
              button.removeAttribute('aria-busy');
            });
        }
      }

      customElements.define('nord-product-card', NordProductCard);
    }
  })();
